import {
  makeKolInfo1,
  makeKolInfo2,
  makeKolInfo3,
} from '@/constants/mock-data/kol-info'
import { SupportedLanguages } from '@/i18n/config'
import { Owner } from '@/types/schema/api/owner-schema'
import {
  EditPredictiveReportCandidateCustomDataResponse,
  EditPredictiveReportCollaborativeItemsResponse,
  FetchPredictiveReportCollaborativeItemEstimatedPriceResponse,
  PredictiveReportCandidateBasicInfoListResponse,
  PredictiveReportCandidateListResponse,
  PredictiveReportCollaborativeItemsResponse,
  PredictiveReportConfigResponse,
  PredictiveReportDetailReportKolsResponse,
  PredictiveReportDetailReportPlatformSubtotalResponse,
  PredictiveReportDetailReportSubtotalResponse,
  PredictiveReportListResponse,
  PredictiveReportSubtotalResponse,
  RefreshPredictiveReportDetailReportSummaryResponse,
} from '@/types/schema/api/predictive-report'
import { collaborativeItemTypeSchema } from '@/types/schema/collaborative-item'
import { willingnessToCollaborateSchema } from '@/types/schema/directory/kol-management'
import {
  PredictiveReport,
  PredictiveReportCandidate,
  PredictiveReportCandidatePlatformAnalysis,
  predictiveReportPlatformShortcodeSchema,
  PredictiveReportSubtotal,
} from '@/types/schema/predictive-report'
import { PlatformShortcode } from '@/utils/convert-platform'

const PREDICTIVE_REPORT_OWNER_MOCK_DATA_1: Owner = {
  id: 15625,
  name: 'Ben Chen',
}

const PREDICTIVE_REPORT_OWNER_MOCK_DATA_2: Owner = {
  id: 44177,
  name: 'Ryan(狀態:家徒四壁',
}

const PREDICTIVE_REPORT_MOCK_DATA_1: PredictiveReport = {
  id: 1,
  name: '空狀態（第一次加入流程）',
  update_at: '1995/09/05',
  kol_count: 0,
  owner: PREDICTIVE_REPORT_OWNER_MOCK_DATA_1,
}

const PREDICTIVE_REPORT_MOCK_DATA_2: PredictiveReport = {
  id: 2,
  name: '全平台豐富資料（第二次加入流程）',
  update_at: '2018/09/05',
  kol_count: 3,
  owner: PREDICTIVE_REPORT_OWNER_MOCK_DATA_2,
}

const PREDICTIVE_REPORT_MOCK_DATA_3: PredictiveReport = {
  id: 3,
  name: '單平台（摘要模糊、自訂欄位未填、爆預算）',
  update_at: '1997/11/07',
  kol_count: 1,
  owner: PREDICTIVE_REPORT_OWNER_MOCK_DATA_2,
}

const PREDICTIVE_REPORT_MOCK_DATA_4: PredictiveReport = {
  id: 4,
  name: '有未解鎖的網紅（一進去就被擋住）',
  update_at: '1996/10/06',
  kol_count: 3,
  owner: PREDICTIVE_REPORT_OWNER_MOCK_DATA_2,
}

const PREDICTIVE_REPORT_MOCK_DATA_5: PredictiveReport = {
  id: 5,
  name: '修改任何東西都會失敗（可憐哪）',
  update_at: '1997/11/07',
  kol_count: 3,
  owner: PREDICTIVE_REPORT_OWNER_MOCK_DATA_2,
}

const PREDICTIVE_REPORT_MOCK_DATA_6: PredictiveReport = {
  id: 6,
  name: '大部分 API 都炸爛（可憐哪 2）',
  update_at: '1997/11/07',
  kol_count: 3,
  owner: PREDICTIVE_REPORT_OWNER_MOCK_DATA_2,
}

const PREDICTIVE_REPORT_MOCK_DATA_7: PredictiveReport = {
  id: 7,
  name: '最主要的 API 直接炸爛（通常在 live demo 時會遇到）',
  update_at: '1997/11/07',
  kol_count: 3,
  owner: PREDICTIVE_REPORT_OWNER_MOCK_DATA_2,
}

const PREDICTIVE_REPORT_SUBTOTAL_MOCK_DATA_1: PredictiveReportSubtotal = {
  estimate_costs: 0,
  total_budget: 1000,
  kol_portfolios: undefined,
  collaborative_items: [],
  platform_estimate_reach: [],
}

const PREDICTIVE_REPORT_SUBTOTAL_MOCK_DATA_2: PredictiveReportSubtotal = {
  estimate_costs: 8000000,
  total_budget: 10000000,
  kol_portfolios: {
    level1: 0,
    level2: 0,
    level3: 0,
    level4: 12,
    level5: 0,
    level6: 3,
    level7: 0,
    level8: 6,
  },
  collaborative_items: [
    {
      metadata: {
        is_custom_platform: false,
        is_custom_collaborative_item: false,
        platform_name: PlatformShortcode.Instagram,
        collaborative_item: collaborativeItemTypeSchema.enum.post,
      },
      collaborative_items_count: 42,
    },
    {
      metadata: {
        is_custom_platform: false,
        is_custom_collaborative_item: false,
        platform_name: PlatformShortcode.Instagram,
        collaborative_item: collaborativeItemTypeSchema.enum.reels,
      },
      collaborative_items_count: 21,
    },
    {
      metadata: {
        is_custom_platform: false,
        is_custom_collaborative_item: false,
        platform_name: PlatformShortcode.Facebook,
        collaborative_item: collaborativeItemTypeSchema.enum.post,
      },
      collaborative_items_count: 2,
    },
    {
      metadata: {
        is_custom_platform: false,
        is_custom_collaborative_item: false,
        platform_name: PlatformShortcode.Facebook,
        collaborative_item: collaborativeItemTypeSchema.enum.live,
      },
      collaborative_items_count: 11,
    },
    {
      metadata: {
        is_custom_platform: false,
        is_custom_collaborative_item: false,
        platform_name: PlatformShortcode.YouTube,
        collaborative_item: collaborativeItemTypeSchema.enum.video,
      },
      collaborative_items_count: 21,
    },
    {
      metadata: {
        is_custom_platform: true,
        is_custom_collaborative_item: true,
        platform_name: 'Dcard',
        collaborative_item: '玩笑',
      },
      collaborative_items_count: 10,
    },
  ],
  platform_estimate_reach: [
    {
      platform: PlatformShortcode.Instagram,
      kpi: {
        post: 10000,
        video: 30000,
        custom_value: 2000,
      },
    },
    {
      platform: PlatformShortcode.Facebook,
      kpi: {
        post: 25000,
        video: 10000,
        custom_value: 5000,
      },
    },
    {
      platform: PlatformShortcode.YouTube,
      kpi: {
        post: 2000,
        video: 1000,
        custom_value: 200,
      },
    },
    {
      platform: 'custom',
      kpi: {
        post: null,
        video: null,
        custom_value: 2000,
      },
    },
  ],
}

const PREDICTIVE_REPORT_SUBTOTAL_MOCK_DATA_3: PredictiveReportSubtotal = {
  estimate_costs: 228000,
  total_budget: 300,
  kol_portfolios: {
    level1: 0,
    level2: 1,
    level3: 0,
    level4: 0,
    level5: 0,
    level6: 0,
    level7: 0,
    level8: 0,
  },
  collaborative_items: [
    {
      metadata: {
        is_custom_platform: false,
        is_custom_collaborative_item: false,
        platform_name: PlatformShortcode.Facebook,
        collaborative_item: collaborativeItemTypeSchema.enum.live,
      },
      collaborative_items_count: 11,
    },
  ],
  platform_estimate_reach: [
    {
      platform: PlatformShortcode.Facebook,
      kpi: {
        post: 25000,
        video: 10000,
        custom_value: 12000,
      },
    },
  ],
}

export const DEFAULT_PLATFORM_RECORD = {
  post: true,
  reels: true,
  live: false,
  story: false,
  video: false,
  shorts: false,
  ad_authorization: false,
  material_authorization: false,
} as const

const PREDICTIVE_REPORT_CONFIG__MOCK_DATA_1: PredictiveReportConfigResponse = {
  predictive_report_id: PREDICTIVE_REPORT_MOCK_DATA_1.id,
  name: PREDICTIVE_REPORT_MOCK_DATA_1.name,
  owner: {
    id: 44543,
    name: 'Edison',
  },
  customized_tags_names: [
    'Art and Entertainment',
    'Beauty and Fashion/Beauty Care',
    'Beauty and Fashion/Perfume',
    'Climate and Environment',
  ],
  platforms: [],
  ig: {
    ...DEFAULT_PLATFORM_RECORD,
    post: true,
    reels: false,
  },
  fb: {
    ...DEFAULT_PLATFORM_RECORD,
    post: true,
    video: false,
    live: true,
  },
  yt: {
    ...DEFAULT_PLATFORM_RECORD,
    video: true,
    live: false,
    shorts: true,
  },
  start_date: '2024-11-01T00:00:00Z',
  end_date: '2024-11-30T23:59:59Z',
  total_budget: 300000,
  created_at: '2024-11-08T18:02:28.372Z',
  updated_at: '2024-11-08T18:02:28.372Z',
  used_collaborative_item_count: 0,
  kol_count: 0,
  is_custom_data_completed: true,
  is_data_changed: false,
  locked_candidate_list: [],
}
const PREDICTIVE_REPORT_CONFIG__MOCK_DATA_2: PredictiveReportConfigResponse = {
  ...PREDICTIVE_REPORT_CONFIG__MOCK_DATA_1,
  predictive_report_id: PREDICTIVE_REPORT_MOCK_DATA_2.id,
  platforms: [
    predictiveReportPlatformShortcodeSchema.options[0].enum.ig,
    predictiveReportPlatformShortcodeSchema.options[0].enum.fb,
    predictiveReportPlatformShortcodeSchema.options[0].enum.yt,
    'custom',
  ],
  name: PREDICTIVE_REPORT_MOCK_DATA_2.name,
  kol_count: PREDICTIVE_REPORT_MOCK_DATA_2.kol_count,
  used_collaborative_item_count: PREDICTIVE_REPORT_MOCK_DATA_2.kol_count * 2,
}
const PREDICTIVE_REPORT_CONFIG__MOCK_DATA_3: PredictiveReportConfigResponse = {
  ...PREDICTIVE_REPORT_CONFIG__MOCK_DATA_1,
  predictive_report_id: PREDICTIVE_REPORT_MOCK_DATA_3.id,
  platforms: [predictiveReportPlatformShortcodeSchema.options[0].enum.fb],
  name: PREDICTIVE_REPORT_MOCK_DATA_3.name,
  kol_count: PREDICTIVE_REPORT_MOCK_DATA_3.kol_count,
  is_custom_data_completed: false,
  is_data_changed: true,
}
const PREDICTIVE_REPORT_CONFIG__MOCK_DATA_5: PredictiveReportConfigResponse = {
  ...PREDICTIVE_REPORT_CONFIG__MOCK_DATA_1,
  predictive_report_id: PREDICTIVE_REPORT_MOCK_DATA_5.id,
  name: PREDICTIVE_REPORT_MOCK_DATA_5.name,
  kol_count: PREDICTIVE_REPORT_MOCK_DATA_5.kol_count,
}
const PREDICTIVE_REPORT_CONFIG__MOCK_DATA_6: PredictiveReportConfigResponse = {
  ...PREDICTIVE_REPORT_CONFIG__MOCK_DATA_1,
  predictive_report_id: PREDICTIVE_REPORT_MOCK_DATA_6.id,
  name: PREDICTIVE_REPORT_MOCK_DATA_6.name,
  kol_count: PREDICTIVE_REPORT_MOCK_DATA_6.kol_count,
}
const PREDICTIVE_REPORT_CONFIG__MOCK_DATA_7: PredictiveReportConfigResponse = {
  ...PREDICTIVE_REPORT_CONFIG__MOCK_DATA_1,
  predictive_report_id: PREDICTIVE_REPORT_MOCK_DATA_7.id,
  name: PREDICTIVE_REPORT_MOCK_DATA_7.name,
  kol_count: PREDICTIVE_REPORT_MOCK_DATA_7.kol_count,
}

export const makePredictiveReportConfigMockData = (
  locale?: SupportedLanguages,
): PredictiveReportConfigResponse => {
  const kolInfo = makeKolInfo3(locale)

  return {
    ...PREDICTIVE_REPORT_CONFIG__MOCK_DATA_1,
    predictive_report_id: PREDICTIVE_REPORT_MOCK_DATA_4.id,
    name: PREDICTIVE_REPORT_MOCK_DATA_4.name,
    kol_count: PREDICTIVE_REPORT_MOCK_DATA_4.kol_count,
    locked_candidate_list: [
      {
        uuid: '0ae3f47c-84f8-419c-93cd-763a63f197ca',
        name: kolInfo.name,
      },
    ],
  }
}

export const makePredictiveReportConfigResponseMockDataMap = (
  locale?: SupportedLanguages,
): {
  [key: string]: PredictiveReportConfigResponse
} => {
  const predictiveReportConfigMockData4 =
    makePredictiveReportConfigMockData(locale)

  return {
    [PREDICTIVE_REPORT_CONFIG__MOCK_DATA_1.predictive_report_id]:
      PREDICTIVE_REPORT_CONFIG__MOCK_DATA_1,
    [PREDICTIVE_REPORT_CONFIG__MOCK_DATA_2.predictive_report_id]:
      PREDICTIVE_REPORT_CONFIG__MOCK_DATA_2,
    [PREDICTIVE_REPORT_CONFIG__MOCK_DATA_3.predictive_report_id]:
      PREDICTIVE_REPORT_CONFIG__MOCK_DATA_3,
    [predictiveReportConfigMockData4.predictive_report_id]:
      predictiveReportConfigMockData4,
    [PREDICTIVE_REPORT_CONFIG__MOCK_DATA_5.predictive_report_id]:
      PREDICTIVE_REPORT_CONFIG__MOCK_DATA_5,
    [PREDICTIVE_REPORT_CONFIG__MOCK_DATA_6.predictive_report_id]:
      PREDICTIVE_REPORT_CONFIG__MOCK_DATA_6,
    [PREDICTIVE_REPORT_CONFIG__MOCK_DATA_7.predictive_report_id]:
      PREDICTIVE_REPORT_CONFIG__MOCK_DATA_7,
  }
}

type PredictiveReportCandidateMockDataMaker = (
  locale?: SupportedLanguages,
) => PredictiveReportCandidate

export const makePredictiveReportCandidateMockData1: PredictiveReportCandidateMockDataMaker =
  (locale) => {
    const kolInfo = makeKolInfo1(locale)

    return {
      uuid: 'f6f281f4-0c36-4cc8-bf96-88cc479cdfdf',
      predictive_report_kol_id: 1,
      name: kolInfo.name,
      is_selected: false,
      platform: PlatformShortcode.Instagram,
      customized_tags: [
        'Art and Entertainment',
        'Beauty and Fashion/Beauty Care',
      ],
      collaborative_items: [
        {
          predictive_report_kol_collaborative_item_id: 1,
          metadata: {
            is_custom_platform: false,
            is_custom_collaborative_item: false,
            platform_name: PlatformShortcode.Instagram,
            collaborative_item: collaborativeItemTypeSchema.enum.post,
          },
          collaborative_items_count: 2,
          cooperation_fee: 2000,
        },
        {
          predictive_report_kol_collaborative_item_id: 2,
          metadata: {
            is_custom_platform: false,
            is_custom_collaborative_item: false,
            platform_name: PlatformShortcode.Facebook,
            collaborative_item: collaborativeItemTypeSchema.enum.video,
          },
          collaborative_items_count: 1,
          cooperation_fee: 3000,
        },
        {
          predictive_report_kol_collaborative_item_id: 3,
          metadata: {
            is_custom_platform: false,
            is_custom_collaborative_item: false,
            platform_name: PlatformShortcode.Facebook,
            collaborative_item: collaborativeItemTypeSchema.enum.post,
          },
          collaborative_items_count: 1,
          cooperation_fee: 2000,
        },
      ],
      follower_level: 'level1',
      kpi: {
        follower_count: kolInfo.follower,
        image_estimated_reach_count: 0,
        video_estimated_reach_count: 0,
        engagement_rate: 0.1,
        view_rate: 0.03,
        follow_count_growth_rate: 0.3,
        engagement_rate_performance: { pr25: 0.01, pr50: 0.2, pr75: 0.3 },
        view_rate_performance: { pr25: 0.01, pr50: 0.2, pr75: 0.3 },
        follow_count_growth_rate_performance: {
          pr25: 0.01,
          pr50: 0.2,
          pr75: 0.3,
        },
        score: 0.8,
        main_audience: {
          main_gender: {
            code: 'Male',
            weight: 0.62,
          },
          main_age: {
            code: '18_24',
            weight: 0.52,
          },
        },
      },
      total_cooperation_fee: 7000,
      posts: [],
      recommend_reason: null,
      willingness_to_collaborate:
        willingnessToCollaborateSchema.enum.to_be_confirmed,
      note: null,
    }
  }

export const makePredictiveReportCandidateMockData2: PredictiveReportCandidateMockDataMaker =
  (locale) => {
    const kolInfo = makeKolInfo2(locale)

    return {
      uuid: 'acecebfe-25e9-4e28-b767-15ebed5f74ab',
      predictive_report_kol_id: 2,
      name: kolInfo.name,
      platform: PlatformShortcode.Instagram,
      customized_tags: [
        'Art and Entertainment',
        'Beauty and Fashion/Beauty Care',
      ],
      is_selected: true,
      collaborative_items: [
        {
          predictive_report_kol_collaborative_item_id: 1,
          metadata: {
            is_custom_platform: false,
            is_custom_collaborative_item: false,
            platform_name: PlatformShortcode.Instagram,
            collaborative_item: collaborativeItemTypeSchema.enum.post,
          },
          collaborative_items_count: 42,
          cooperation_fee: 2000,
        },
        {
          predictive_report_kol_collaborative_item_id: 2,
          metadata: {
            is_custom_platform: false,
            is_custom_collaborative_item: false,
            platform_name: PlatformShortcode.Instagram,
            collaborative_item: collaborativeItemTypeSchema.enum.reels,
          },
          collaborative_items_count: 21,
          cooperation_fee: 3000,
        },
        {
          predictive_report_kol_collaborative_item_id: 3,
          metadata: {
            is_custom_platform: false,
            is_custom_collaborative_item: false,
            platform_name: PlatformShortcode.Facebook,
            collaborative_item: collaborativeItemTypeSchema.enum.live,
          },
          collaborative_items_count: 11,
          cooperation_fee: 3000,
        },
        {
          predictive_report_kol_collaborative_item_id: 4,
          metadata: {
            is_custom_platform: true,
            is_custom_collaborative_item: true,
            platform_name: 'Dcard',
            collaborative_item: '玩笑',
          },
          collaborative_items_count: 10,
          cooperation_fee: 2000,
        },
      ],
      total_cooperation_fee: 10000,
      follower_level: 'level2',
      kpi: {
        follower_count: kolInfo.follower,
        engagement_rate: 0.057,
        view_rate: 0.28,
        follow_count_growth_rate: 0.008,
        engagement_rate_performance: { pr25: 0.01, pr50: 0.2, pr75: 0.3 },
        view_rate_performance: { pr25: 0.01, pr50: 0.2, pr75: 0.3 },
        follow_count_growth_rate_performance: {
          pr25: 0.01,
          pr50: 0.2,
          pr75: 0.3,
        },
        image_estimated_reach_count: 10000,
        video_estimated_reach_count: 30000,
        main_audience: {
          main_gender: {
            code: 'Male',
            weight: 0.62,
          },
          main_age: {
            code: '18_24',
            weight: 0.52,
          },
        },
        score: 80,
      },
      posts: [
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '302805759',
          post_id: 'DBYtXXvvrDj',
          ig_post_id: '3395088039888124616',
          title: '',
          content:
            '肉丸不能亂吃，話也不能亂講\n情人眼裡出濾鏡，真的怎麼看都漂亮\n不信你tag另一半問問\n\n#愛是在惹火對方前先滅火 \n#來IKEA約會吧\n#約會聖地IKEA',
          thumbnail_url:
            'https://thumbnail.kolradar.com/instagram-post/3395088039888124616',
          link: 'https://www.instagram.com/p/DBYtXXvvrDj',
          like_count: 1006,
          comment_count: 12,
          watch_count: 109481,
          mentioned_uuids: [],
        },
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '8717007006',
          post_id: 'DBVk_AyPM6b',
          ig_post_id: '3387841904665942872',
          title: '',
          content:
            '大家知道端午節除了立蛋，還可以挑戰「立瓜」嗎？\n\n屏東佳冬鄉素有「西瓜原鄉」美名，是培育西瓜苗的重要地區，當地睽違四年舉辦端午節立瓜活動，10日午時在石光見廣惠宮前封街「立瓜」，800顆大西瓜排排站，畫面相當壯觀。\n\n��公所表示，佳冬雖不常見西瓜田，但石光見一帶以嫁接西瓜苗枝技術聞名，目前全台約六成以上西瓜出自佳冬鄉民種苗，所以「立瓜」活動現場也提供瓜苗嫁接體驗，小朋友親身實踐後直說，原來西瓜不是從西瓜籽開始種植。\n\n此外，大家知道當地農民是將西瓜苗嫁接到哪些作物上嗎？更多內容，請點 @taiwanyahoonews 主頁連結內圖片👀\n\n圖片來源：中央社\n\n#端午 #端午節 #立蛋 #立瓜 #屏東 #佳冬 #石光見 #西瓜 #大西瓜 #種苗 #嫁接 #體驗 #封街 #活動 #農會 #農業 #端午立蛋 #長知識 #yahoo新聞 #yahoo #yahoonews',
          thumbnail_url:
            'https://thumbnail.kolradar.com/instagram-post/3387841904665942872',
          link: 'https://www.instagram.com/p/DBYtXXvvrDj',
          like_count: 292,
          comment_count: 3,
          watch_count: 0,
          mentioned_uuids: [],
        },
        {
          platform_type: PlatformShortcode.Instagram,
          crawler_id: '3451650438',
          post_id: 'DBLutKISS_O',
          ig_post_id: '3337806419120247453',
          title: '',
          content:
            '這次真的好大。願大家都平安，都保重…That was a big one. Wishing blessings and safety to all 🙏',
          thumbnail_url:
            'https://thumbnail.kolradar.com/instagram-post/3337806419120247453',
          link: 'https://www.instagram.com/p/DBYtXXvvrDj',
          like_count: 31817,
          comment_count: 580,
          watch_count: 0,
          mentioned_uuids: [],
        },
      ],
      recommend_reason:
        '上好美盤，上好美盤，上好美盤，上好美盤，上好美盤，上好美盤，上好美盤，上好美盤，上好美盤，上好美盤，上好美盤。',
      willingness_to_collaborate: willingnessToCollaborateSchema.enum.willing,
      note: '你得叫我派大星教授加博士先生。',
    }
  }

export const makePredictiveReportCandidateMockData3: PredictiveReportCandidateMockDataMaker =
  (locale) => {
    const kolInfo = makeKolInfo3(locale)

    return {
      uuid: '0ae3f47c-84f8-419c-93cd-763a63f197ca',
      predictive_report_kol_id: 3,
      name: kolInfo.name,
      is_selected: false,
      platform: PlatformShortcode.Facebook,
      customized_tags: [
        'Art and Entertainment',
        'Beauty and Fashion/Beauty Care',
      ],
      kpi: {
        follower_count: kolInfo.follower,
        image_estimated_reach_count: null,
        video_estimated_reach_count: null,
        engagement_rate: null,
        view_rate: null,
        follow_count_growth_rate: null,
        engagement_rate_performance: null,
        view_rate_performance: null,
        follow_count_growth_rate_performance: null,
        score: null,
        main_audience: {
          main_gender: null,
          main_age: null,
        },
      },
      collaborative_items: [
        {
          predictive_report_kol_collaborative_item_id: 1,
          metadata: {
            is_custom_platform: false,
            is_custom_collaborative_item: false,
            platform_name: PlatformShortcode.Instagram,
            collaborative_item: collaborativeItemTypeSchema.enum.post,
          },
          collaborative_items_count: 42,
          cooperation_fee: 2000,
        },
        {
          predictive_report_kol_collaborative_item_id: 2,
          metadata: {
            is_custom_platform: false,
            is_custom_collaborative_item: false,
            platform_name: PlatformShortcode.Facebook,
            collaborative_item: collaborativeItemTypeSchema.enum.post,
          },
          collaborative_items_count: 2,
          cooperation_fee: 2000,
        },
      ],
      total_cooperation_fee: 0,
      follower_level: null,
      posts: [],
      recommend_reason: null,
      willingness_to_collaborate: willingnessToCollaborateSchema.enum.unwilling,
      note: null,
    }
  }

export const makeAllMockCandidateList = (
  locale?: SupportedLanguages,
): PredictiveReportCandidate[] => {
  const predictiveReportCandidateMockData1 =
    makePredictiveReportCandidateMockData1(locale)
  const predictiveReportCandidateMockData2 =
    makePredictiveReportCandidateMockData2(locale)
  const predictiveReportCandidateMockData3 =
    makePredictiveReportCandidateMockData3(locale)

  return [
    predictiveReportCandidateMockData1,
    predictiveReportCandidateMockData2,
    predictiveReportCandidateMockData3,
    {
      ...predictiveReportCandidateMockData1,
      predictive_report_kol_id: 4,
      uuid: '41d3f78e-d519-46dc-8432-3aaa94620af9',
      name: '41d3f78e',
    },
    {
      ...predictiveReportCandidateMockData2,
      predictive_report_kol_id: 5,
      uuid: '74645e26-28d2-4ddd-a147-e515aa77ff9a',
      name: '74645e26',
    },
    {
      ...predictiveReportCandidateMockData1,
      predictive_report_kol_id: 6,
      uuid: 'fdc0996e-5124-4412-8aa3-ad9c709887de',
      name: 'fdc0996e',
    },
    {
      ...predictiveReportCandidateMockData2,
      predictive_report_kol_id: 7,
      uuid: 'f5567f6e-751e-45e1-b84f-4b5539ba266b',
      name: 'f5567f6e',
    },
    {
      ...predictiveReportCandidateMockData1,
      predictive_report_kol_id: 8,
      uuid: 'c2c002eb-d7ea-4f17-935c-672e176df120',
      name: 'c2c002eb',
    },
    {
      ...predictiveReportCandidateMockData1,
      predictive_report_kol_id: 9,
      uuid: '854b16d5-06f9-43dd-bc69-6d1a815df06c',
      name: '854b16d5',
    },
    {
      ...predictiveReportCandidateMockData2,
      predictive_report_kol_id: 10,
      uuid: 'c96b1f55-53fc-4b6f-92c2-8e3707bcdd50',
      name: 'c96b1f55',
    },
  ]
}

export const makePredictiveReportCandidateListResponseMockData = (
  locale?: SupportedLanguages,
): PredictiveReportCandidateListResponse => {
  const allMockCandidateList = makeAllMockCandidateList(locale)

  return {
    data: {
      list: allMockCandidateList,
      total_selected: allMockCandidateList.filter(
        (candidate) => candidate.is_selected,
      ).length,
    },
    total: allMockCandidateList.length,
    page: 1,
    per_page: 10,
    total_page: 1,
  }
}

const PREDICTIVE_REPORT_CANDIDATE_LIST_RESPONSE_MOCK_DATA: PredictiveReportCandidateListResponse =
  {
    data: { list: [], total_selected: 0 },
    total: 0,
    page: 1,
    per_page: 10,
    total_page: 1,
  }

export const makePredictiveReportCandidateListResponseMockDataMap = (
  locale?: SupportedLanguages,
): {
  [key: string]: PredictiveReportCandidateListResponse
} => {
  const predictiveReportCandidateListResponseMockData1 =
    PREDICTIVE_REPORT_CANDIDATE_LIST_RESPONSE_MOCK_DATA

  const predictiveReportCandidateListResponseMockData2 =
    makePredictiveReportCandidateListResponseMockData(locale)

  const predictiveReportCandidateListResponseMockData3: PredictiveReportCandidateListResponse =
    predictiveReportCandidateListResponseMockData2

  const predictiveReportCandidateListResponseMockData4 =
    makePredictiveReportCandidateListResponseMockData(locale)

  const predictiveReportCandidateListResponseMockData5: PredictiveReportCandidateListResponse =
    predictiveReportCandidateListResponseMockData2
  const predictiveReportCandidateListResponseMockData6: PredictiveReportCandidateListResponse =
    predictiveReportCandidateListResponseMockData2
  const predictiveReportCandidateListResponseMockData7: PredictiveReportCandidateListResponse =
    predictiveReportCandidateListResponseMockData2

  return {
    [predictiveReportMockData1.id]:
      predictiveReportCandidateListResponseMockData1,
    [predictiveReportMockData2.id]:
      predictiveReportCandidateListResponseMockData2,
    [predictiveReportMockData3.id]:
      predictiveReportCandidateListResponseMockData3,
    [predictiveReportMockData4.id]:
      predictiveReportCandidateListResponseMockData4,
    [predictiveReportMockData5.id]:
      predictiveReportCandidateListResponseMockData5,
    [predictiveReportMockData6.id]:
      predictiveReportCandidateListResponseMockData6,
    [predictiveReportMockData7.id]:
      predictiveReportCandidateListResponseMockData7,
  }
}

export const makePredictiveReportCandidateCooperationContentsResponseMockData =
  (locale?: SupportedLanguages): PredictiveReportCollaborativeItemsResponse => {
    const mockResponse =
      makePredictiveReportCandidateListResponseMockData(locale)

    return {
      kol_collaborative_items: mockResponse.data.list
        .map((candidate) =>
          candidate.collaborative_items.map((item, i) => ({
            kol_uuid: candidate.uuid,
            name: candidate.name,
            predictive_report_kol_id: candidate.predictive_report_kol_id,
            predictive_report_kol_collaborative_item_id: i,
            metadata: {
              platform_name: item.metadata.platform_name,
              is_custom_platform: item.metadata.is_custom_platform,
              collaborative_item: item.metadata.collaborative_item,
              is_custom_collaborative_item:
                item.metadata.is_custom_collaborative_item,
            },
            collaborative_items_count: item.collaborative_items_count,
            cooperation_fee: item.cooperation_fee,
            ai_predicted_single_cooperation_fee: 500,
            is_custom_data: true,
            custom_data: {
              like_count: null,
              comment_count: null,
              share_count: null,
              view_count: null,
              reach_count: null,
              click_count: null,
            },
          })),
        )
        .flat(),
    }
  }

export const makePredictiveReportCandidateUuidListResponseMockData = (
  locale?: SupportedLanguages,
): PredictiveReportCandidateBasicInfoListResponse => {
  const mockResponse = makePredictiveReportCandidateListResponseMockData(locale)

  return {
    kols: mockResponse.data.list.map((candidate) => ({
      kol_uuid: candidate.uuid,
      platforms: ['ig', 'fb', 'yt'],
      name: candidate.name,
    })),
  }
}

const PREDICTIVE_REPORT_DETAIL_REPORT_SUBTOTAL_RESPONSE_MOCK_DATA: PredictiveReportDetailReportSubtotalResponse =
  {
    estimate_value: {
      budget: 50000,
      cost: 45000,
      cpe: 25,
      cpv: 32,
      cpev: 3,
      womm: 10000,
    },
    estimate_effectiveness: {
      like_count: 5000,
      comment_count: 300,
      share_count: 100,
      engagement_count: 5400,
      view_count: 20000,
      reach_count: 25000,
      click_count: 1,
    },
    summary: [
      'summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1 summary1',
      'summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222 summary222',
    ],
  }

const PREDICTIVE_REPORT_DETAIL_REPORT_PLATFORM_SUBTOTAL_RESPONSE_MOCK_DATA: PredictiveReportDetailReportPlatformSubtotalResponse =
  {
    estimate_value: {
      cpe: 25,
      cpv: 32,
      cpev: 3,
      womm: 10000,
    },
    estimate_effectiveness: {
      like_count: 5000,
      click_count: 0,
      comment_count: 300,
      share_count: 100,
      engagement_count: 5400,
      view_count: 20000,
      reach_count: 25000,
      engagement_rate: 0.27,
      view_rate: 0.8,
      reach_rate: 1.0,
    },
  }

type PredictiveReportCandidatePlatformAnalysisMockDataMaker = (
  locale?: SupportedLanguages,
) => PredictiveReportCandidatePlatformAnalysis

export const makePredictiveReportCandidatePlatformAnalysisMockData1: PredictiveReportCandidatePlatformAnalysisMockDataMaker =
  (locale) => {
    const kolInfo = makeKolInfo1(locale)

    return {
      uuid: 'f6f281f4-0c36-4cc8-bf96-88cc479cdfdf',
      predictive_report_kol_id: 1,
      name: kolInfo.name,
      collaborative_items: [
        {
          predictive_report_kol_collaborative_item_id: 1,
          metadata: {
            is_custom_platform: false,
            is_custom_collaborative_item: false,
            platform_name: PlatformShortcode.Instagram,
            collaborative_item: collaborativeItemTypeSchema.enum.post,
          },
          collaborative_items_count: 2,
          cooperation_fee: 2000,
        },
        {
          predictive_report_kol_collaborative_item_id: 2,
          metadata: {
            is_custom_platform: false,
            is_custom_collaborative_item: false,
            platform_name: PlatformShortcode.Facebook,
            collaborative_item: collaborativeItemTypeSchema.enum.video,
          },
          collaborative_items_count: 1,
          cooperation_fee: 3000,
        },
        {
          predictive_report_kol_collaborative_item_id: 3,
          metadata: {
            is_custom_platform: false,
            is_custom_collaborative_item: false,
            platform_name: PlatformShortcode.Facebook,
            collaborative_item: collaborativeItemTypeSchema.enum.post,
          },
          collaborative_items_count: 1,
          cooperation_fee: 2000,
        },
      ],
      kpi: {
        estimated_like_count: 13000,
        estimated_comment_count: 2000,
        estimated_share_count: 1333,
        estimated_view_count: 1000400,
        estimated_avg_view_rate: 0.2,
        estimated_engagement_count: 50000,
        estimated_engagement_rate: 0.2,
        estimated_reach_count: 71000,
        estimated_reach_rate: 0.1,
        estimated_click_count: 20400,
      },
    }
  }

export const makePredictiveReportCandidatePlatformAnalysisMockData2: PredictiveReportCandidatePlatformAnalysisMockDataMaker =
  (locale) => {
    const kolInfo = makeKolInfo2(locale)

    return {
      uuid: 'acecebfe-25e9-4e28-b767-15ebed5f74ab',
      predictive_report_kol_id: 2,
      name: kolInfo.name,
      collaborative_items: [
        {
          predictive_report_kol_collaborative_item_id: 1,
          metadata: {
            is_custom_platform: false,
            is_custom_collaborative_item: false,
            platform_name: PlatformShortcode.Instagram,
            collaborative_item: collaborativeItemTypeSchema.enum.post,
          },
          collaborative_items_count: 42,
          cooperation_fee: 2000,
        },
        {
          predictive_report_kol_collaborative_item_id: 2,
          metadata: {
            is_custom_platform: false,
            is_custom_collaborative_item: false,
            platform_name: PlatformShortcode.Instagram,
            collaborative_item: collaborativeItemTypeSchema.enum.reels,
          },
          collaborative_items_count: 21,
          cooperation_fee: 3000,
        },
        {
          predictive_report_kol_collaborative_item_id: 3,
          metadata: {
            is_custom_platform: false,
            is_custom_collaborative_item: false,
            platform_name: PlatformShortcode.Facebook,
            collaborative_item: collaborativeItemTypeSchema.enum.live,
          },
          collaborative_items_count: 11,
          cooperation_fee: 3000,
        },
        {
          predictive_report_kol_collaborative_item_id: 4,
          metadata: {
            is_custom_platform: true,
            is_custom_collaborative_item: true,
            platform_name: 'Dcard',
            collaborative_item: '玩笑',
          },
          collaborative_items_count: 10,
          cooperation_fee: 2000,
        },
      ],
      kpi: {
        estimated_like_count: 2000,
        estimated_comment_count: 600,
        estimated_share_count: 122,
        estimated_view_count: 188000,
        estimated_engagement_count: 3333,
        estimated_reach_count: 6800,
        estimated_click_count: 2400,
      },
    }
  }

export const makePredictiveReportDetailReportKolsResponseMockData = (
  locale?: SupportedLanguages,
): PredictiveReportDetailReportKolsResponse => {
  const predictiveReportCandidatePlatformAnalysisMockData1 =
    makePredictiveReportCandidatePlatformAnalysisMockData1(locale)
  const predictiveReportCandidatePlatformAnalysisMockData2 =
    makePredictiveReportCandidatePlatformAnalysisMockData2(locale)

  return {
    data: [
      predictiveReportCandidatePlatformAnalysisMockData1,
      predictiveReportCandidatePlatformAnalysisMockData2,
    ],
    total: 2,
    page: 1,
    per_page: 10,
    total_page: 1,
  }
}

export const makeFetchPredictiveReportCollaborativeItemEstimatedPriceResponseMockData =
  (
    locale?: SupportedLanguages,
  ): FetchPredictiveReportCollaborativeItemEstimatedPriceResponse => {
    const predictiveReportCandidateMockData1 =
      makePredictiveReportCandidateMockData1(locale)

    return {
      ai_predicted_single_cooperation_fees: [
        {
          ad_authorization: 29900,
          material_authorization: 19900,
          uuid: predictiveReportCandidateMockData1.uuid,
          platform: PlatformShortcode.Instagram,
          post: 1999,
          video: 5999,
        },
      ],
    }
  }

const predictiveReportMockData1 = PREDICTIVE_REPORT_MOCK_DATA_1
const predictiveReportMockData2 = PREDICTIVE_REPORT_MOCK_DATA_2
const predictiveReportMockData3 = PREDICTIVE_REPORT_MOCK_DATA_3
const predictiveReportMockData4 = PREDICTIVE_REPORT_MOCK_DATA_4
const predictiveReportMockData5 = PREDICTIVE_REPORT_MOCK_DATA_5
const predictiveReportMockData6 = PREDICTIVE_REPORT_MOCK_DATA_6
const predictiveReportMockData7 = PREDICTIVE_REPORT_MOCK_DATA_7

const predictiveReportListResponseMockData: PredictiveReportListResponse = {
  data: [
    PREDICTIVE_REPORT_MOCK_DATA_1,
    PREDICTIVE_REPORT_MOCK_DATA_2,
    PREDICTIVE_REPORT_MOCK_DATA_3,
    PREDICTIVE_REPORT_MOCK_DATA_4,
    PREDICTIVE_REPORT_MOCK_DATA_5,
    PREDICTIVE_REPORT_MOCK_DATA_6,
    PREDICTIVE_REPORT_MOCK_DATA_7,
  ],
  total: 6,
  page: 1,
  per_page: 10,
  total_page: 1,
}

const predictiveReportSubtotalMockData1 = PREDICTIVE_REPORT_SUBTOTAL_MOCK_DATA_1
const predictiveReportSubtotalMockData2 = PREDICTIVE_REPORT_SUBTOTAL_MOCK_DATA_2
const predictiveReportSubtotalMockData3 = PREDICTIVE_REPORT_SUBTOTAL_MOCK_DATA_3
const predictiveReportSubtotalMockData4: PredictiveReportSubtotal = {
  ...PREDICTIVE_REPORT_SUBTOTAL_MOCK_DATA_2,
}
const predictiveReportSubtotalMockData5: PredictiveReportSubtotal = {
  ...PREDICTIVE_REPORT_SUBTOTAL_MOCK_DATA_2,
}
const predictiveReportSubtotalMockData6: PredictiveReportSubtotal = {
  ...PREDICTIVE_REPORT_SUBTOTAL_MOCK_DATA_2,
}
const predictiveReportSubtotalMockData7: PredictiveReportSubtotal = {
  ...PREDICTIVE_REPORT_SUBTOTAL_MOCK_DATA_2,
}

const predictiveReportSubtotalResponseMockDataMap: {
  [key: string]: PredictiveReportSubtotalResponse
} = {
  [PREDICTIVE_REPORT_MOCK_DATA_1.id]: predictiveReportSubtotalMockData1,
  [PREDICTIVE_REPORT_MOCK_DATA_2.id]: predictiveReportSubtotalMockData2,
  [PREDICTIVE_REPORT_MOCK_DATA_3.id]: predictiveReportSubtotalMockData3,
  [PREDICTIVE_REPORT_MOCK_DATA_4.id]: predictiveReportSubtotalMockData4,
  [PREDICTIVE_REPORT_MOCK_DATA_5.id]: predictiveReportSubtotalMockData5,
  [PREDICTIVE_REPORT_MOCK_DATA_6.id]: predictiveReportSubtotalMockData6,
  [PREDICTIVE_REPORT_MOCK_DATA_7.id]: predictiveReportSubtotalMockData7,
}

const predictiveReportCandidateListResponseMockData1 =
  PREDICTIVE_REPORT_CANDIDATE_LIST_RESPONSE_MOCK_DATA

const predictiveReportDetailReportSubtotalResponseMockData =
  PREDICTIVE_REPORT_DETAIL_REPORT_SUBTOTAL_RESPONSE_MOCK_DATA

const predictiveReportDetailReportPlatformSubtotalResponseMockData =
  PREDICTIVE_REPORT_DETAIL_REPORT_PLATFORM_SUBTOTAL_RESPONSE_MOCK_DATA

const editPredictiveReportDetailReportCollaborativeItemsResponseMockData: EditPredictiveReportCollaborativeItemsResponse =
  { id: PREDICTIVE_REPORT_MOCK_DATA_1.id }
const editPredictiveReportDetailReportCollaborativeItemsDetailResponseMockData: EditPredictiveReportCandidateCustomDataResponse =
  { id: PREDICTIVE_REPORT_MOCK_DATA_1.id }

const refreshPredictiveReportDetailReportSummaryResponseMockData: RefreshPredictiveReportDetailReportSummaryResponse =
  undefined

export {
  editPredictiveReportDetailReportCollaborativeItemsDetailResponseMockData,
  editPredictiveReportDetailReportCollaborativeItemsResponseMockData,
  predictiveReportCandidateListResponseMockData1,
  predictiveReportDetailReportPlatformSubtotalResponseMockData,
  predictiveReportDetailReportSubtotalResponseMockData,
  predictiveReportListResponseMockData,
  predictiveReportMockData1,
  predictiveReportMockData2,
  predictiveReportMockData3,
  predictiveReportMockData4,
  predictiveReportMockData5,
  predictiveReportMockData6,
  predictiveReportMockData7,
  predictiveReportSubtotalMockData1,
  predictiveReportSubtotalMockData2,
  predictiveReportSubtotalMockData3,
  predictiveReportSubtotalMockData4,
  predictiveReportSubtotalMockData5,
  predictiveReportSubtotalMockData6,
  predictiveReportSubtotalMockData7,
  predictiveReportSubtotalResponseMockDataMap,
  refreshPredictiveReportDetailReportSummaryResponseMockData,
}
